import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, BookMarked, Clock } from 'lucide-react';

const PanduanIbadah = () => {
    const TakbirIcon = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d4af37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="5" r="2.5" fill="#d4af37" stroke="none" />
            <path d="M12 8v8" />
            <path d="M12 16l-3 6" />
            <path d="M12 16l3 6" />
            <path d="M12 9H8V5" />
            <path d="M12 9h4V5" />
        </svg>
    );

    const topics = [
        { icon: <TakbirIcon />, label: 'Tata Cara Shalat' },
        { icon: '🕋', label: 'Panduan Haji & Umroh' },
        { icon: '🌙', label: 'Puasa Ramadhan' },
        { icon: '💰', label: 'Zakat & Infaq' },
        { icon: '☝️', label: 'Dzikir & Wirid' },
        { icon: '🤲', label: 'Doa-doa Khusus' },
    ];

    return (
        <div className="pt-24 min-h-screen bg-[#081c1a] animate-fade-in-up flex flex-col">
            <div className="container mx-auto px-6 py-8 flex-1">
                <Link to="/belajar-islam" className="inline-flex items-center gap-2 text-muted-foreground hover:text-gold transition-colors mb-10 group">
                    <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
                    Kembali ke Belajar Islam
                </Link>

                <div className="flex flex-col items-center justify-center min-h-[70vh] text-center">
                    <div className="relative mb-10">
                        <div className="w-40 h-40 rounded-full bg-amber-500/5 border border-amber-500/10 flex items-center justify-center mx-auto">
                            <div className="w-28 h-28 rounded-full bg-amber-500/10 border border-amber-500/20 flex items-center justify-center">
                                <BookMarked size={52} className="text-amber-400" />
                            </div>
                        </div>
                        <div className="absolute -top-2 -right-2 w-8 h-8 bg-gold/20 rounded-full border border-gold/40 flex items-center justify-center">
                            <Clock size={14} className="text-gold" />
                        </div>
                    </div>



                    <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6">
                        Segera <span className="text-gold">Hadir</span>
                    </h1>
                    <p className="text-xl text-muted-foreground max-w-xl leading-relaxed mb-10">
                        Panduan ibadah lengkap dan mudah dipahami sedang kami siapkan. Mulai dari tata cara shalat hingga panduan haji & umroh.
                    </p>

                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 max-w-md w-full mb-12">
                        {topics.map((t) => (
                            <div key={t.label} className="glass-card px-4 py-3 rounded-xl border border-white/10 flex items-center gap-2">
                                <span className="text-xl flex justify-center items-center w-6 h-6">{t.icon}</span>
                                <span className="text-sm text-muted-foreground">{t.label}</span>
                            </div>
                        ))}
                    </div>

                    <div className="glass-card p-6 rounded-2xl border border-white/10 max-w-sm w-full">
                        <p className="text-muted-foreground text-sm mb-1">Tim kami sedang bersiap</p>
                        <div className="w-full h-2 bg-white/10 rounded-full overflow-hidden">
                            <div className="h-full bg-gradient-to-r from-amber-500 to-gold rounded-full" style={{ width: '50%' }} />
                        </div>
                        <p className="text-xs text-muted-foreground mt-2">50% selesai</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PanduanIbadah;
